import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import StandardPageTemplate from '../../../../common/components/Layout/StandardPageTemplate';
import { LogoutMenuItem } from '../../../../common/components/Layout/Header/MenuConfig';
import withQuery from '../../../../common/components/withQuery';
import withCustomerOrg from '../../../../common/components/withCustomerOrg';
import NotFoundView from '../../../../common/components/NotFound';
import CurrentUserActions from '../../../../redux-modules/current-user';
import ActivitiesPage from '../ActivitiesPage';
import Surveys from '../Surveys';
import GetInvolvedPage from '../GetInvolvedPage';
import LandingPage from '../LandingPage';
import AuthRoute from '../AuthRoute';
import MembershipCardModal from '../MembershipCard/Modal';
import MembershipInfo from '../MembershipInfo';
import PreferencesPage from '../PreferencesPage';
import PrivacyPage from '../PrivacyPage';
import TransactionsPage from '../TransactionsPage';

const AccountPageNotFound = () => {
  return (
    <NotFoundView
      title="404"
      subtitle="This page is not found, please return to your account page."
      reactRouterLocation="/"
      redirectMessage="Return"
    />
  );
};

class AccountLayout extends React.Component {
  static propTypes = {
    version: PropTypes.string,
    location: PropTypes.shape({
      query: PropTypes.shape({
        cst: PropTypes.string,
      }),
    }),
    currentUser: PropTypes.shape({
      id: PropTypes.string,
    }),
    actions: PropTypes.shape({
      currentUser: PropTypes.object,
    }),
  };
  static childContextTypes = {
    activateMemberhipCard: PropTypes.func,
  };
  state = {
    cardActive: false,
  };

  componentWillMount() {
    const { currentUser, location: { query }, actions } = this.props;
    if (query && query.cst && query.cst !== currentUser.id) {
      actions.currentUser.setId(query.cst);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  getChildContext = () => {
    return {
      activateMemberhipCard: this.toggleActive,
    };
  };

  toggleActive = active => {
    ga('send', 'event', 'MembershipCard', 'open', 'Opened Membership Card');
    this.setState(prevState => ({
      ...prevState,
      cardActive:
        typeof active === 'undefined' ? !prevState.cardActive : !!active,
    }));
  };

  renderChildComponent = Component => props => {
    const { currentUser, currentCustomer } = this.props;
    const forwardProps = {
      currentUser,
      currentCustomer,
      currentOrganization: (currentCustomer || {}).organization,
    };
    return <Component {...props} {...forwardProps} />;
  };

  render() {
    const { match: { path } } = this.props;
    return (
      <StandardPageTemplate
        defaultDocTitle="Account | NFIB"
        menuItems={[LogoutMenuItem]}
      >
        <Switch>
          <AuthRoute
            exact
            path={`${path}(/)?`}
            render={this.renderChildComponent(LandingPage)}
          />
          <AuthRoute
            path={`${path}/edit`}
            render={this.renderChildComponent(MembershipInfo)}
          />
          <AuthRoute
            path={`${path}/transactions`}
            render={this.renderChildComponent(TransactionsPage)}
          />
          <AuthRoute
            path={`${path}/events`}
            render={this.renderChildComponent(ActivitiesPage)}
          />
          <Route
            path={`${path}/surveys`}
            render={this.renderChildComponent(Surveys)}
          />
          <Route
            path={`${path}/preferences`}
            render={this.renderChildComponent(PreferencesPage)}
          />
          <AuthRoute
            path={`${path}/get-involved`}
            render={this.renderChildComponent(GetInvolvedPage)}
          />
          <AuthRoute
            path={`${path}/privacy`}
            render={this.renderChildComponent(PrivacyPage)}
          />
          <AuthRoute component={AccountPageNotFound} />
        </Switch>
        <MembershipCardModal
          active={this.state.cardActive}
          toggleActive={this.toggleActive}
        />
      </StandardPageTemplate>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      currentUser: bindActionCreators(CurrentUserActions, dispatch),
    },
  };
};

export default connect(null, mapDispatchToProps)(
  withQuery(withCustomerOrg(AccountLayout))
);



// WEBPACK FOOTER //
// ./src/App/account/components/AccountLayout/index.js